var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-down scroll-down-button",class:{ active: _vm.isScrollVisible },attrs:{"id":"scroll-btn"},on:{"click":function($event){return _vm.handleClickScrool()}}},[_c('img',{staticClass:"slide__down--button scroll-down-button",attrs:{"src":_vm.slide}})])
}
var staticRenderFns = []

export { render, staticRenderFns }